// Module
var code = "<react-component name=\"ContactsList\"></react-component>\n";
// Exports
module.exports = code;